import React from 'react';
import { Box } from '@mui/material';
import { STATUTS } from '../../utils/rh';

/** Pastille de statut journalier. compact : code court (grilles). */
const StatutChip = ({ statut, compact = false, title }) => {
  const s = STATUTS[statut] || { label: statut, code: '?', bg: '#eee', fg: '#333' };
  return (
    <Box component="span" title={title || s.label}
      sx={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', borderRadius: 1,
        bgcolor: s.bg, color: s.fg, fontWeight: 600, whiteSpace: 'nowrap',
        ...(compact ? { width: 28, height: 24, fontSize: 11 } : { px: 1, py: 0.25, fontSize: 12.5 }),
        border: statut === 'EN_ATTENTE' || statut === 'A_VENIR' ? '1px dashed #C3C9D1' : 'none',
      }}>
      {compact ? s.code : s.label}
    </Box>
  );
};

export default StatutChip;
